import React from 'react';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

class AppErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {error: null};
    }

    static getDerivedStateFromError(error) {
        return {error};
    }

    componentDidCatch(error, info) {
        console.error('App error boundary caught an error:', error, info);
    }

    reset = () => {
        this.setState({error: null});
    };

    reload = () => {
        window.location.reload();
    };

    render() {
        if (!this.state.error) return this.props.children;

        return (
            <Box
                sx={{
                    minHeight: '100dvh',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    bgcolor: 'background.default',
                    color: 'text.primary',
                    p: 3,
                }}
            >
                <Paper sx={{maxWidth: 560, p: 3}}>
                    <Stack spacing={2}>
                        <Alert severity="error">Something went wrong while rendering this screen.</Alert>
                        <Typography variant="body2" color="text.secondary">
                            The app recovered from a UI error. You can retry the screen or reload the page.
                        </Typography>
                        <Stack direction="row" spacing={1} justifyContent="flex-end">
                            <Button onClick={this.reset} variant="outlined">
                                Try again
                            </Button>
                            <Button onClick={this.reload} variant="contained">
                                Reload page
                            </Button>
                        </Stack>
                    </Stack>
                </Paper>
            </Box>
        );
    }
}

export default AppErrorBoundary;
